<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-group"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Smart Safe
              </div>
            </template>
            <v-data-table
              :headers="safeheaders"
              :items="getsmartsaferates"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Monthly Rates</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Rate
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedItem.group"
                                :items="groupsmartsafelist"
                                label="Group"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.billingemail"
                                label="Billing Email"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.rate"
                                :rules="dollar_cents_only"
                                label="rate"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="savesmartsaferate"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-truck"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Virtual/Postal Safe
              </div>
            </template>
            <v-data-table
              :headers="virtualheaders"
              :items="getvirtualrates"
              :search="virtualsearch"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Monthly Rates</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="virtualsearch"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialogvirt"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Rate
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedVirtualItem.group"
                                :items="groupvirtuallist"
                                label="Group"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedVirtualItem.billingemail"
                                label="Billing Email"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedVirtualItem.rate"
                                :rules="dollar_cents_only"
                                label="rate"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closevirt"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="savesvirtualrate"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    data: () => ({
      dialog: false,
      dialogvirt: false,
      dialogDelete: false,
      locations: [],
      numberofsitesbygroup: [],
      search: '',
      virtualsearch: '',
      dollar_cents_only: [
        v => !isNaN(v) || 'Please format as 0.00',
      ],
      safeheaders: [
        { text: 'Group', align: 'center', sortable: true, value: 'group' },
        { text: 'Count', align: 'center', sortable: true, value: 'count' },
        { text: 'Billing Email', align: 'center', sortable: true, value: 'billingemail' },
        { text: 'Rate', align: 'center', sortable: true, value: 'rate' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      rels: [],
      editedIndex: -1,
      editedItem: {
        group: '',
        billingemail: '',
        billingmethod: '',
        count: '',
        rate: '',
        key: '',
      },
      defaultItem: {
        group: '',
        billingemail: '',
        billingmethod: '',
        count: 0,
        rate: '',
        key: '',
      },
      virtualheaders: [
        { text: 'Group', align: 'center', sortable: true, value: 'group' },
        { text: 'Count', align: 'center', sortable: true, value: 'count' },
        { text: 'Billing Email', align: 'center', sortable: true, value: 'billingemail' },
        { text: 'Rate', align: 'center', sortable: true, value: 'rate' },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      vrates: [],
      editedVirtualIndex: -1,
      editedVirtualItem: {
        group: '',
        rate: '',
        count: 0,
        billingemail: '',
        billingmethod: '',
        key: '',
      },
      defaultVirtualItem: {
        group: '',
        rate: '',
        count: 0,
        billingemail: '',
        billingmethod: '',
        key: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Release' : 'Change Rate'
      },
      groupvirtuallist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        let groupspresent = this.vrates.map(element => element.group)
        let filtered
        filtered = groups.filter(item => !groupspresent.includes(item))
        return filtered
      },
      groupsmartsafelist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        let groupspresent = this.rels.map(element => element.group)
        let filtered
        filtered = groups.filter(item => !groupspresent.includes(item))
        return filtered
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getsmartsaferates () {
        this.rels = this.$store.getters.getSmartSafeRates.reverse()
        this.rels.forEach(element => {
          let grpcount = 0
          grpcount = this.numberofsitesbygroup[element.group]
          Object.assign(element, { count: grpcount })
        })
        return this.rels
      },
      getvirtualrates () {
        this.vrates = this.$store.getters.getVirtualRates.reverse()
        this.vrates.forEach(element => {
          let grpcount = 0
          grpcount = this.numberofsitesbygroup[element.group]
          Object.assign(element, { count: grpcount })
        })
        // get the records
        // get the units per group
        return this.vrates
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogvirt (val) {
        val || this.closevirt()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.rels = []
      this.$store.dispatch('loadsmartsaferates')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadsaferates')
      this.$store.dispatch('loadvirtualrates')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.getlocs()
    },
    methods: {
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            this.$log.debug('rej count is ', rejcount)

            let shop = {
              idnum: key,
              safeid: safeid,
              group: loc.group,
              sitename: name,
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        // get the groups
        let grouplist = this.$store.getters.usergroups.map(
          group => group.name
        )
        // loop thru locations
        grouplist.forEach(element => {
          let rec
          let count = 0
          count = this.locations.filter(loc => loc.group === element).length
          this.numberofsitesbygroup[element] = count
        })
        // get count
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      editItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closevirt () {
        this.dialogvirt = false
        this.$nextTick(() => {
          this.editedVirtualItem = Object.assign({}, this.defaultVirtualItem)
          this.editedVirtualIndex = -1
        })
      },
      getnumberofsites () {
        let sites
      // get all the sites
      // get all the sites with safes
      // count sites with safes by group
      },
      savesvirtualrate () {
        if (this.editedVirtualIndex > -1) {
          Object.assign(this.rels[this.editedVirtualIndex], this.editedVirtualItem)
          // this.$store.dispatch('updaterelease', this.editedItem)
        } else {
          this.vrates.push(this.editedVirtualItem)
          this.$store.dispatch('createvirtualrate', this.editedVirtualItem)
          // this.$store.dispatch('createrelease', this.editedItem)
        }
        this.$store.dispatch('loadvirtualrates')
        this.closevirt()
      },
      savesmartsaferate () {
        if (this.editedIndex > -1) {
          Object.assign(this.rels[this.editedIndex], this.editedItem)
          // this.$store.dispatch('updaterelease', this.editedItem)
        } else {
          this.rels.push(this.editedItem)
          this.$store.dispatch('createsmartsaferate', this.editedItem)
          // this.$store.dispatch('createrelease', this.editedItem)
        }
        this.$store.dispatch('loadsmartsaferates')
        this.close()
      },
    },
  }
</script>
